export default __webpack_public_path__ + "static/media/bdt_projectCardDefault.61e7843b.jpg";